"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["size", "color", "accessibleTitle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @deprecated Use <Icon icon="padlock" /> instead
 */
var Padlock = function Padlock(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 25 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000' : _ref$color,
    _ref$accessibleTitle = _ref.accessibleTitle,
    accessibleTitle = _ref$accessibleTitle === void 0 ? 'Padlock icon' : _ref$accessibleTitle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    style: {
      width: size,
      height: size
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, otherProps), accessibleTitle ? /*#__PURE__*/_react["default"].createElement("title", null, accessibleTitle) : null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M13 6.333h-.5V4.5a4.5 4.5 0 10-9 0v1.833H3c-.736 0-1.333.597-1.333 1.334v7C1.667 15.403 2.264 16 3 16h10c.736 0 1.333-.597 1.333-1.333v-7c0-.737-.597-1.334-1.333-1.334zm-6.333 4a1.333 1.333 0 112 1.149V13a.667.667 0 11-1.334 0v-1.518a1.33 1.33 0 01-.666-1.149zM5.167 4.5a2.833 2.833 0 115.666 0V6a.333.333 0 01-.333.333h-5A.333.333 0 015.167 6V4.5z"
  }));
};
Padlock.propTypes = {
  size: _propTypes["default"].number,
  color: _propTypes["default"].string,
  accessibleTitle: _propTypes["default"].string
};
var _default = exports["default"] = Padlock;